
import { Box,Center,Input } from "@chakra-ui/react";
import { PaymentForm } from "../components/checkout/PaymentForm";
import axios from "axios";
// import { PaymentForm } from "../components/checkout/PaymentForm";
import {
    Alert,
    AlertIcon,
    AlertTitle,
    AlertDescription,
  } from '@chakra-ui/react'
  import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { cartAction } from "../redux/prod/action";


export default function  Payment(){
    const [e,setE]=useState(false);
    const navigate=useNavigate()
    const dispatch=useDispatch();
    const onClick=async ()=>{
      const token=localStorage.getItem("isLogged");
      if(token){
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        let res=await axios.get("https://real-cyan-rooster-ring.cyclic.app/logout")
        // console.log(k.data);
        const data=res.data
        dispatch(cartAction(data))
        console.log(data);
      }
        setE(true);
        setTimeout(()=>{
          navigate("/")
        },2000)

    }
    return(
        <>
        <Center>
         <Box
                p={'20px'}
                my={'30px'}
                mx={'auto'}
                maxW={'1200px'}
                display={'flex'}
                gap={['40px', '40px', '40px', '10%', '10%']}
                gridTemplateColumns={['100%', '100%', '100%', '55% 35%', '60% 30%']}
                flexDirection={'column'}
            >
                {e?<Alert
  status='success'
  variant='subtle'
  flexDirection='column'
  alignItems='center'
  justifyContent='center'
  textAlign='center'
  height='200px'
>
  <AlertIcon boxSize='40px' mr={0} />
  <AlertTitle mt={4} mb={1} fontSize='lg'>
    Order Placed
  </AlertTitle>
  <AlertDescription maxWidth='sm'>
    Thanks for Shopping
  </AlertDescription>
</Alert>:""}
  {/* <Center> */}
                <PaymentForm  />

                {/* <CheckoutOrderSummary /> */}
                {/* <PlaceOrderBtn  /> */}
                {/* </Center> */}
                <Input
                onClick={onClick}
                mt="4"
                as={'button'}
                type={'submit'}
                h={"60px"}
                bg={'#edf2f7'}
                color={'black'}
                border={`1px solid #cecdce`}
                borderRadius={"50px"}
                w={"100%"}
                fontSize={"17px"}
                // mt={'20px'}
                _hover={{ borderColor: 'black' }}
            >
                Place Order
            </Input>
            </Box>
            </Center>
    </>
    );
};